module.exports = __webpack_public_path__ + "img/gravier_roule_blanc_bleu.3f9601c9.jpg";